import "@vidstack/react/player/styles/default/theme.css";
import "@vidstack/react/player/styles/default/layouts/audio.css";
import { themeColors } from "@/utils/themeColors";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import { DefaultAudioLayout, defaultLayoutIcons } from "@vidstack/react/player/layouts/default";
import { useMediaPlayerContextSelector } from "../hooks/useMediaPlayerContext";
import { DownloadButton } from "./VideoPlayer";

const AudioPlayer = ({
    src,
    chaptersUrl,
    containerStyle,
}: {
    src: string;
    chaptersUrl?: string;
    containerStyle?: React.CSSProperties;
}) => {
    const setMediaPlayerRef = useMediaPlayerContextSelector(state => state.setMediaPlayerRef);

    const renderDownloadButton = () => {
        return <DownloadButton src={src} />;
    };

    return (
        <MediaPlayer
            ref={ref => {
                setMediaPlayerRef(ref);
            }}
            src={src}
            controls
            style={{ background: "transparent", border: "none", ...containerStyle }}>
            <MediaProvider style={{ visibility: "hidden", position: "absolute" }}>
                {chaptersUrl && <track
                    src={chaptersUrl}
                    label="English"
                    srcLang="en-US"
                    kind="chapters"
                    default
                    data-testid="auto-id-16a04841-0fd8-4701-872c-c150a8c3485d" />}
            </MediaProvider>
            <DefaultAudioLayout
                icons={defaultLayoutIcons}
                colorScheme="light"
                style={{
                    border: `1px solid ${themeColors.neutral1}`,
                    boxShadow: "none",
                    filter: "none",
                }}
                slots={{
                    settingsMenuEndItems: renderDownloadButton(),
                }}
            />
            <style data-testid="auto-id-17c98a67-0ea0-4e06-b2c6-6e864c077471">
                {`  
                    .vds-controls{
                        display:unset !important;
                    }
                    
                    .vds-menu-items{
                        --media-menu-y-offset: -377px;
                    }

                    .vds-settings-menu-items{
                        --media-menu-y-offset: -126px;
                    }

                    .vds-menu-items:where(.vds-menu-items:not([data-submenu]):not([data-placement])){
                        right: calc(-850.333px ) !important;
                        width:100px;
                        top: calc(-277px + calc(-1 * -520px)) !important;

                    }

                    .vds-slider-chapter-title{
                        color: ${themeColors.neutralBlack};
                    }

                    `}
            </style>
        </MediaPlayer>
    );
};

export default AudioPlayer;
